module.exports = __webpack_public_path__ + "img/lsftdSmall.f1da4f20.jpg";